import { render, staticRenderFns } from "./PorletBuscador.vue?vue&type=template&id=11047466&"
import script from "./PorletBuscador.vue?vue&type=script&lang=js&"
export * from "./PorletBuscador.vue?vue&type=script&lang=js&"
import style0 from "./PorletBuscador.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports